import { useState } from "react";
import { Hero } from "@/sections/Hero";
import { Marquee } from "@/sections/Marquee";
import { MainServices } from "@/sections/MainServices";
import { ServiceCatalog } from "@/sections/ServiceCatalog";
import { Approach } from "@/sections/Approach";
import { WhyUs } from "@/sections/WhyUs";
import { Packages } from "@/sections/Packages";
import { AgenticAI } from "@/sections/AgenticAI";
import { Portfolio } from "@/sections/Portfolio";
import { Founder } from "@/sections/Founder";
import { Faq } from "@/sections/Faq";
import { ConsultSection } from "@/sections/ConsultSection";
import { Footer } from "@/sections/Footer";
import { Seo } from "@/components/Seo";
import { scrollToId } from "@/lib/api";
import { usePay } from "@/lib/pay";
import { track } from "@/lib/analytics";

export default function Landing() {
  const [preset, setPreset] = useState(null);
  const { pay, paying } = usePay();
  const consult = (service, location = "home") => {
    track("consultation_click", { service, location });
    setPreset({ service, t: Date.now() });
    setTimeout(() => scrollToId("contact"), 50);
  };
  return (
    <main data-testid="landing-page">
      <Seo title="Website Development in Pune, Local SEO & AI Automation | SwayamScale"
        description="SwayamScale AI Business Agency, Pune: websites for small businesses, Google Business Profile, local SEO, AEO and AI automation. Book a free consultation."
        path="/" />
      <Hero onConsult={consult} />
      <Marquee />
      <MainServices onConsult={consult} />
      <Packages onConsult={consult} onPay={pay} paying={paying} />
      <AgenticAI onConsult={consult} onPay={pay} paying={paying} />
      <ServiceCatalog onConsult={consult} onPay={pay} paying={paying} />
      <WhyUs />
      <Approach />
      <Portfolio />
      <Founder />
      <Faq />
      <ConsultSection preset={preset} />
      <Footer />
    </main>
  );
}
